import { LayoutContext } from 'contexts/LayoutContext';
import { useDripsyTheme } from 'dripsy';

import { useContext } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';

import { AccountDetailsTabParamList, AccountDetailsTabRoutes } from './type';
import { useTranslation } from 'react-i18next';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { TextSmall } from '@/design-system/components/typography';
import { Icon } from '@/design-system/components/icons/Icon';

import { AccountDetailsAccountScreen } from './AccountDetailsAccount.screen';
import { AccountDetailsCardScreen } from './AccountDetailsCard.screen';

const AccountDetailsTab = createBottomTabNavigator<AccountDetailsTabParamList>();

export const AccountDetailsNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.Details>> = ({ route }) => {
  const { account, tab, record, flag, options } = route.params;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);
  const props = layout.isMobile && record?.cardAccountId && flag != '1' ? {} : { tabBar: () => null };
  const { theme } = useDripsyTheme();

  const tabBarOptions = {
    paddingY: '$1',
    tabBarActiveTintColor: '#000000',
    tabBarInactiveTintColor: '#999999'
  };

  return (
    <AccountDetailsTab.Navigator
      initialRouteName={AccountDetailsTabRoutes.Account}
      screenOptions={{
        headerShown: false,
        unmountOnBlur: true,
        tabBarStyle: {
          height: 60,
          paddingTop: 8,
          paddingBottom: 8,
          shadowOffset: {
            width: 0,
            height: -10
          },
          shadowOpacity: 0.1,
          shadowRadius: 10,
          elevation: 0,
          backgroundColor: '$tabBarBackgroundColor',
          borderTopWidth: 0
        },
        tabBarItemStyle: {
          flexDirection: 'column'
        }
      }}
      sceneContainerStyle={{ backgroundColor: (theme.colors?.$backgroundSecondary as string) || 'transparent' }}
      detachInactiveScreens={true}
      {...props}>
      <AccountDetailsTab.Screen
        name={AccountDetailsTabRoutes.Account}
        component={AccountDetailsAccountScreen}
        initialParams={{ record, account: record?.id, tab: undefined || 0, flag }}
        options={{
          ...tabBarOptions,
          tabBarLabel: ({ focused }) => (
            <TextSmall semiBold sx={{ mt: '$1', color: focused ? '$navbarTextActive' : '$navbarTextInactive' }}>
              {t('card-account-management::account-page.text--account')}
            </TextSmall>
          ),
          tabBarIcon: ({ focused }) => (
            <Icon name={focused ? 'earnNavPortfolioActive' : 'earnNavPortfolioInactive'} height={28} width={28} />
          )
        }}
      />
      <AccountDetailsTab.Screen
        name={AccountDetailsTabRoutes.Card}
        component={AccountDetailsCardScreen}
        initialParams={{ record, account: record?.cardAccountId, tab: 1, flag, options }}
        options={{
          ...tabBarOptions,
          tabBarLabel: ({ focused }) => (
            <TextSmall semiBold sx={{ mt: '$1', color: focused ? '$navbarTextActive' : '$navbarTextInactive' }}>
              {t('card-account-management::account-page.text--card')}
            </TextSmall>
          ),
          tabBarIcon: ({ focused }) => <Icon name={focused ? 'cardActiveNative' : 'cardInactiveNative'} height={28} width={28} />
        }}
      />
    </AccountDetailsTab.Navigator>
  );
};
